
export default {
  languageName: {
    fi: () => "suomeksi",
    sv: () => "på svenska",
    en: () => "in English"
  },
  mainContentLinkText: () => "Gå direkt till innehåll",
  verification: {
    cancelButtonText: () => "Avbryt"
  },
  cancelConfirmation: {
    title: () => "Vill du avbryta?",
    body: () => "Om du avbryter inloggningen, kan du inte fortsätta att sköta dina ärenden i tjänsten.",
    yes: () => "Avbryt",
    no: () => "Tillbaka"
  },
  authenticationCancelError: {
    title: () => "Identifieringen avbröts",
    body: () => "Dina uppgifter förmedlades inte."
  },
  loggedOut: {
    title: () => "Du har loggats ut ur tjänsten",
    body: () => "Om du vill kan du logga in i tjänsten på nytt.",
    close: () => "Stäng"
  },
  footer: {
    dataprotectionLinkText: () => "Dataskydd inom OP",
    accessibilityLinkText: () => "Tillgänglighetsutlåtande",
    accessibilityLinkTarget: () => "https://www.op.fi/tillganglighet/identifiering-tillganglighetsutlatande",
    termsLinkText: () => "Användarvillkor",
    copyrightText: () => "© OP Pohjola"
  },
  applicationError: {
    title: () => "Störning i tjänsten, vi beklagar",
    body: () => "Tjänsten är inte tillgänglig just nu. Var god och försök på nytt senare."
  },
  forbiddenError: {
    title: () => "Identifieringen lyckades inte",
    body: () => "Det går inte att logga in i den här tjänsten med den kod du har gett. Kontakta vid behov din andelsbank eller OP:s kundtjänst."
  },
  passwordChangeRequired: {
    title: () => "Identifieringen lyckas inte",
    body: () => "Du måste byta lösenord. Byt lösenord i tjänsten op.fi."
  },
  selectRepresentationError: {
    title: () => "Störning i tjänsten, vi beklagar",
    body: () => "Det går inte att välja kundprofil just nu. Var god och försök på nytt senare."
  },
  fethRepresentationsError: {
    title: () => "Hämtning av kundprofiler misslyckades",
    body: () => "Försök på nytt om en stund. Kontakta vid behov din andelsbank eller OP:s kundtjänst."
  },
  authSectionDivider: () => "ELLER",
  trustnetwork: {
    title: () => "Andra identifieringssätt",
    privacyText: () => "Vid identifieringen förmedlas följande uppgifter till OP: personbeteckning, namn.",
    privacyLinkText: () => "Dataskyddsbeskrivning",
    privacyLinkTarget: () => "https://isb.op.fi/privacy-info?lang=sv"
  },
  idkaart: {
    title: () => "Logga in med det estniska id-kortet"
  },
  representation: {
    title: () => "Välj kundprofil",
    titleChange: () => "Byt kundprofil",
    privateCustomer: () => "Privatkund",
    companyCustomer: () => "Företagskund",
    companyId: () => "FO-numret",
    doubleAgreement: {
      YOP: () => "(OP-nättjänstavtal för företag)",
      KOPA: () => "(Nättjänstavtal för företagstjänster)",
      YRVEIKKO: () => "(Företagsförsäkringsavtal)",
      YDAS: () => "(Avtal om digital kommunikation)"
    },
    search: {
      title: () => "Sök företag",
      placeholder: () => "Ange företagets namn eller FO-nummer",
      noResults: () => "Inga sökresultat",
      ariaLabel: () => "Att skriva kommer att beskära din företagslista automatiskt"
    },
    back: () => "Tillbaka",
    current: () => "din nuvarande kundprofil"
  },
  accessibility: {
    loading: () => "Laddas",
    businessId: () => "FO-numret",
    welcomeMessage: {
      op: () => "Logga in med OP:s koder.",
      other: () => "Logga in med OP:s koder eller välj ett annat identifieringssätt."
    },
    representationlist: {
      onePersonOneCompany: () => "Välj din kundprofil: privatkund eller företagskund.",
      noPersonManyCompanies: () => "Välj din kundprofil. Du har [COUNT] företagsprofiler.",
      onePersonManyCompanies: () => "Välj din kundprofil: privatkund eller företagskund. Du har [COUNT] företagsprofiler."
    },
    languageNotification: () => "Sidans språk har ändrats till svenska"
  }
}